import React from 'react';
import { styled } from '@linaria/react';

import Paper from '@/components/Paper';
import ClientOnlySnippet from '@/components/CodeSnippet/ClientOnlySnippet';
import type { ClientLanguage } from '@/components/CodeSnippet/CodeSnippet.types';

import type { FileInterface } from './FileViewer.types';

interface Props extends React.ComponentProps<typeof Paper> {
  file: FileInterface;
}

const FileContent = ({ file, ...delegated }: Props) => {
  const extension = getExtension(file.name);

  let lang = extension;
  if (lang === 'js') {
    lang = 'jsx';
  }

  return (
    <Wrapper {...delegated}>
      <CodeSnippet
        lockedToColorMode="light"
        includeContentStyles={false}
        code={file.contents}
        lang={lang}
        fontSize="0.875rem"
      />
    </Wrapper>
  );
};

function getExtension(fileName: string): ClientLanguage {
  const segments = fileName.split('.');
  const extension = segments[segments.length - 1] as ClientLanguage;

  return extension;
}

const Wrapper = styled(Paper)`
  display: flex;
  background: white;
  border-radius: 4px;
  padding: 0;
  overflow: auto;
  min-height: var(--min-content-height);
  max-height: var(--max-content-height);
`;

const CodeSnippet = styled(ClientOnlySnippet)`
  flex: 1;
  --code-snippet-height: 100%;
`;

export default FileContent;
